import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import EnquiryModal from "../../Components/EnquiryModal";
import "../../App.css";

import bracing_angle_1100 from "../../Assets/bracing_angle_1100.webp";
import suspension_channel_long from "../../Assets/suspension_channel_long.webp";
import barbed_Wire from "../../Assets/barbed_Wire.webp";
import barbed_wire_clamp from "../../Assets/barbed_wire_clamp.webp";
import bird_guard from "../../Assets/bird_guard.webp";
import cross_arm_clamp from "../../Assets/cross_arm_clamp.webp";
import danger_board from "../../Assets/danger_board.webp";
import danger_board_Clamp from "../../Assets/danger_board_Clamp.webp";
import dp_cut_point_channel from "../../Assets/dp_cut_point_channel.webp";
import four_hole_flat from "../../Assets/four-hole-flat.webp";
import gi_wire_8swg from "../../Assets/gi_wire_8swg.webp";
import guarding_channel from "../../Assets/guarding_channel.webp";
import hdgi_nutbolt_with_washer from "../../Assets/hdgi_nutbolt_with_washer.webp";
import ht_earthing_pipe_plate_welded from "../../Assets/ht_earthing_pipe_plate_welded.webp";
import ht_stay_Set from "../../Assets/ht_stay_Set.webp";
import ht_stay_wire from "../../Assets/ht_stay_wire.webp";
import i_bolt from "../../Assets/i_bolt.webp";
import stay_clamp from "../../Assets/stay_clamp.webp";
import thimble from "../../Assets/thimble.webp";
import three_hole_flat from "../../Assets/three-hole-flat.webp";
import u_bolt from "../../Assets/u_bolt.webp";
import wedge_connector from "../../Assets/wedge-connector.webp";
import HT_stay_insulator from "../../Assets/HT_stay_insulator.webp";

function SPDC_PAN() {
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const openEnquiryModal = (product) => {
    setSelectedProduct(product);
    setShowEnquiry(true);
  };
  const products = [
    {
      id: 1,
      name: "Bracing angle 1100 mm",
      image: bracing_angle_1100,
      specs: {
        application: "Pole Cross Bracing",
        material: "Mild Steel (MS) / GI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "8,000 Units / Month",
      },
    },
    {
      id: 2,
      name: "Suspension Channel Long",
      image: suspension_channel_long,
      specs: {
        application: "Conductor Support",
        material: "Mild Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "9,000 Units / Month",
      },
    },
    {
      id: 3,
      name: "Thimble",
      image: thimble,
      specs: {
        application: "Stay Wire Loop Protection",
        material: "Forged Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "10,000 Units / Month",
      },
    },
    {
      id: 4,
      name: "Stay Clamp",
      image: stay_clamp,
      specs: {
        application: "Electrical Line Hardware",
        material: "Forged Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "10,000 Units / Month",
      },
    },
    {
      id: 5,
      name: "Wedge Connector",
      image: wedge_connector,
      specs: {
        application: "Power Line Accessories",
        material: "Aluminium Alloy",
        finish: "Corrosion Resistant Alloy Finish",
        color: "Grey",
        warranty: "1 Year",
        supply: "7,500 Units / Month",
      },
    },
    {
      id: 6,
      name: "Cross Arm Clamp",
      image: cross_arm_clamp,
      specs: {
        application: "Fixing Cross Arm to Pole",
        material: "GI Steel",
        finish: "Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "6,000 Units / Month",
      },
    },
    {
      id: 7,
      name: "Three Hole Flat",
      image: three_hole_flat,
      specs: {
        application: "Line Fittings",
        material: "Mild Steel",
        finish: "Hot Dip Galvanized",
        color: "Metal Grey",
        warranty: "1 Year",
        supply: "6,500 Units / Month",
      },
    },
    {
      id: 8,
      name: "Four Hole Flat",
      image: four_hole_flat,
      specs: {
        application: "Electrical Hardware",
        material: "Mild Steel (MS)",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "12,000 Units / Month",
      },
    },
    {
      id: 9,
      name: "Dp Cut Point Channel",
      image: dp_cut_point_channel,
      specs: {
        application: "Power Transmission",
        material: "Mild Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "12,000 Units / Month",
      },
    },
    {
      id: 10,
      name: "U-Bolt",
      image: u_bolt,
      specs: {
        application: "Overhead Line Hardware",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "15,000 Units / Month",
      },
    },
    {
      id: 11,
      name: "Guarding Channel",
      image: guarding_channel,
      specs: {
        application: "Overhead Transmission Lines",
        material: "Mild Steel",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "5,000 Units / Month",
      },
    },
    {
      id: 12,
      name: "I-Bolt",
      image: i_bolt,
      specs: {
        application: "Insulator & Stay Connection",
        material: "Galvanized Steel",
        finish: "Hot Dip Galvanized",
        color: "Metallic",
        warranty: "1 Year",
        supply: "20,000 Units / Month",
      },
    },
    {
      id: 13,
      name: "Barbed Wire",
      image: barbed_Wire,
      specs: {
        application: "Security Fencing for Substation / Yard",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "5,000 Units / Month",
      },
    },
    {
      id: 14,
      name: "GI Wire 8 SWG",
      image: gi_wire_8swg,
      specs: {
        application: "Binding / Earthing / General Purpose",
        material: "Galvanized Iron (GI)",
        finish: "Hot Dip Galvanized",
        color: "Grey",
        warranty: "1 Year",
        supply: "Project Based",
      },
    },
    {
      id: 15,
      name: "HT Stay Wire",
      image: ht_stay_wire,
      specs: {
        application: "Pole Support & Tensioning",
        material: "High Tensile Galvanized Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 16,
      name: "HT Earthing Pipe Plate Welded",
      image: ht_earthing_pipe_plate_welded,
      specs: {
        application: "Earthing / Grounding System",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 17,
      name: "HT Stay Set",
      image: ht_stay_Set,
      specs: {
        application: "Complete Pole Stay Assembly",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 18,
      name: "Danger Board",
      image: danger_board,
      specs: {
        application: "Insulator String Hardware",
        material: "MS Sheet / FRP Sheet",
        finish: "Powder Coated / Painted",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Units / Month",
      },
    },
    {
      id: 19,
      name: "Danger Board Clamp",
      image: danger_board_Clamp,
      specs: {
        application: "Fixing Danger Board to Pole",
        material: "HDGI Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Units / Month",
      },
    },
    {
      id: 20,
      name: "Bird Guard",
      image: bird_guard,
      specs: {
        application: "Prevent Bird Nesting on Insulator / Cross Arm",
        material: "Galvanized Steel",
        finish: "Hot Dip Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Units / Month",
      },
    },
    {
      id: 21,
      name: "Barbed Wire Clamp",
      image: barbed_wire_clamp,
      specs: {
        application: "Joining & Tightening Barbed Wire for Fencing",
        material: "Aluminium Alloy / Steel",
        finish: "Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 22,
      name: "HDGI Nutbolt with Washer",
      image: hdgi_nutbolt_with_washer,
      specs: {
        application: "Joining & Tightening Barbed Wire for Fencing",
        material: "Aluminium Alloy / Steel",
        finish: "Galvanized",
        color: "Silver",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
    {
      id: 23,
      name: "HT Stay Insulator",
      image: HT_stay_insulator,
      specs: {
        application: "Insulating stay wire in overhead line installations",
        material: "Porcelain",
        finish: "Glazed",
        color: "Brown",
        warranty: "1 Year",
        supply: "25,000 Sets / Month",
      },
    },
  ];

  const itemsPerPage = 12;
  const totalPages = Math.ceil(products.length / itemsPerPage);

  const currentProducts = products.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <Container>
      <Row className="mt-5">
        {currentProducts.map((product) => (
          <Col md={6} key={product.id} className="mb-4">
            <Card className="product-card-box h-100">
              <Row className="g-0">
                <Col md={5} className="p-3 text-center">
                  <Card.Img
                    src={product.image}
                    alt={product.name}
                    style={{ maxHeight: "220px", objectFit: "contain" }}
                  />
                </Col>

                <Col md={7}>
                  <Card.Body>
                    <Card.Title className="fw-bold text-dark">
                      {product.name}
                    </Card.Title>

                    <div className="small text-muted mb-3">
                      <div>
                        <strong>Application:</strong>{" "}
                        {product.specs.application}
                      </div>
                      <div>
                        <strong>Material:</strong> {product.specs.material}
                      </div>
                      <div>
                        <strong>Finish:</strong> {product.specs.finish}
                      </div>
                      <div>
                        <strong>Color:</strong> {product.specs.color}
                      </div>
                      <div>
                        <strong>Warranty:</strong> {product.specs.warranty}
                      </div>
                      <div>
                        <strong>Supply Capacity:</strong> {product.specs.supply}
                      </div>
                    </div>

                    <button
                      className="btn btn-primary"
                      onClick={() => openEnquiryModal(product)}
                    >
                      Send Enquiry
                    </button>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Pagination */}
      <div className="text-center my-4">
        <button
          className="btn btn-outline-primary mx-2"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          Previous
        </button>

        <span className="fw-semibold">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className="btn btn-outline-primary mx-2"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          Next
        </button>
      </div>

      {showEnquiry && selectedProduct && (
        <EnquiryModal
          show={showEnquiry}
          onHide={() => setShowEnquiry(false)}
          product={selectedProduct}
        />
      )}
    </Container>
  );
}

export default SPDC_PAN;
